export const STATUS = {
  INITIAL: "",
  LOADING: "loading",
  SUCCESS: "success",
  FAIL: "fail"
};
